import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

/* ── Royal Crest Icon ── */
const Crest = (p) => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
    <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
    <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
  </svg>
);

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const location = useLocation();
  const navigate = useNavigate();

  // ── SCROLL & HASH ROUTING MANAGER ──
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        requestAnimationFrame(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.pathname, location.hash]);

  // ── HEADER SCROLL STATE ──
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ── MOBILE SCROLL LOCK ──
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = ''; 
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  const handleLogoClick = () => {
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);

    if (location.pathname === '/') {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  /* ── Clean Navigation Array ── */
  /* ── Clean Navigation Array ── */
  const navLinks = [
    { type: 'route', path: '/', label: 'Home' },
    { type: 'section', id: 'details', label: 'Details' },
    { type: 'section', id: 'gallery', label: 'Gallery' },
    { 
      type: 'section', 
      id: 'gifts', 
      label: 'Send a Gift', 
      hoverLabel: 'To the Chief of Staff' 
    },  
    { type: 'route', path: '/avatar', label: 'Create Avatar' },  
    { type: 'route', path: '/messages', label: 'Leave a Message' },
    { type: 'route', path: '/registration', label: 'Register', hoverLabel: 'Thanksgiving' },  
  ];

  /* ── Helper to render the swap text ── */
  const renderLinkLabel = (link) => {
    if (!link.hoverLabel) return link.label;
    return (
      <span className="text-swap-container">
        <span className="swap-default">{link.label}</span>
        <span className="swap-hover">{link.hoverLabel}</span>
      </span>
    );
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'navbar--open' : ''}`}>
        <div className="nav-container">
          
          <Link to="/" className="nav-logo" onClick={handleLogoClick}>
            <Crest className="logo-icon" />
            <span className="logo-text">Grace in Motion</span>
          </Link>

          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {navLinks.map((link) => (
              <li key={link.id || link.path}>
                {link.type === 'route' ? (
                  <Link 
                    to={link.path} 
                    className={location.pathname === link.path ? 'active' : ''}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {renderLinkLabel(link)}
                  </Link>
                ) : (
                  <a 
                    href={`#${link.id}`} 
                    onClick={(e) => handleSectionClick(e, link.id)}
                  >
                    {renderLinkLabel(link)}
                  </a>
                )}
              </li>
            ))}
          </ul>
          
        </div>
      </nav>
    </>
  );
}